module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-2-f21fe33615f163ab110aeb5623a42592.jpg";